import { useTranslation } from 'react-i18next';

export default function MedicalSection({
    medicalInformation,
    specialOccasion,
    onMedicalChange,
    onOccasionChange,
    lang
}) {

    const { t } = useTranslation();

    return (

        <>
            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Información importante")}</h2>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="medicalInformation" className="u-form-control-hidden u-label fontmontserrat">{t("¿Existe alguna información médica que debamos conocer sobre algún miembro del grupo (alergias, epilepsia, diabetes, etc.)?")}</label>
                <textarea
                    rows="5"
                    value={medicalInformation}
                    placeholder={t("¿Existe alguna información médica que debamos conocer sobre algún miembro del grupo (alergias, epilepsia, diabetes, etc.)?")}
                    id="medicalInformation"
                    name="medicalInformation"
                    onChange={(e) => onMedicalChange(e.target.value)}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="specialOccasion" className="u-form-control-hidden u-label fontmontserrat">{t("¿Celebrarán alguna ocasión especial durante el chárter (cumpleaños, aniversario, etc.)?")}</label>
                <textarea
                    rows="4"
                    value={specialOccasion}
                    placeholder={t("¿Celebrarán alguna ocasión especial durante el chárter (cumpleaños, aniversario, etc.)?")}
                    id="specialOccasion"
                    name="specialOccasion"
                    onChange={(e) => onOccasionChange(e.target.value)}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>
        </>

    );

}
